import { useEffect } from 'react';

const AdBanner = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      
    }
  }, []);

  return (
    <ins className="adsbygoogle"
         style={{ display: "block", textAlign: "center", margin: "30px 0" }}
         data-ad-client="ca-pub-6929208033302101"
         data-ad-slot="6925007517" 
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>
  );
};

export default AdBanner;
